import { render } from "./ModalAdministrar.vue?vue&type=template&id=f64fca9c&scoped=true"
import script from "./ModalAdministrar.vue?vue&type=script&lang=js"
export * from "./ModalAdministrar.vue?vue&type=script&lang=js"

import "./ModalAdministrar.vue?vue&type=style&index=0&id=f64fca9c&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64fca9c"]])

export default __exports__